import * as THREE from "three";
import EventEmitter from "./Utils/EventEmitter.js";
import Resources from "./Utils/Resources.js";
import sources from "./sources.js";
import Sizes from "./Utils/Sizes.js";
import Time from "./Utils/Time.js";
import Camera from "./Camera.js";
import Renderer from "./Renderer.js";
import World from "./World/World.js";
import Raycaster from "./Utils/Raycaster.js";

let instance = null;

export default class Experience extends EventEmitter {
  constructor(_canvas) {
    super();

    if (instance) {
      return instance;
    }
    instance = this;

    window.experience = this;
    this.canvas = _canvas;

    this.sizes = new Sizes();
    this.time = new Time();
    this.scene = new THREE.Scene();
    this.resources = new Resources(sources);
    this.camera = new Camera();
    this.renderer = new Renderer();
    this.raycaster = new Raycaster();
    this.world = new World();

    // Resize Event
    this.sizes.on("resize", () => {
      this.resize();
    });

    // Time Tick Event  
    this.time.on("tick", () => {
      this.update();
    });

    // Emit ready event when all resources are loaded
    this.resources.on("ready", () => {
      this.trigger("ready");
    });
  }

  resize() {
    this.camera.resize();
    this.renderer.resize();
  }

  update() {
    this.camera.update();
    this.world.update();
    this.renderer.update();
  }

  dispose() {
    // Dispose World objects (handles all 3D resources)
    if (this.world?.dispose) {
      this.world.dispose();
    }

    // Dispose utilities (they handle their own DOM event cleanup)
    if (this.raycaster?.dispose) {
      this.raycaster.dispose();
    }

    // Dispose renderer
    if (this.renderer?.instance) {
      this.renderer.instance.dispose();
    }

    // Clear scene
    if (this.scene) {
      this.scene.clear();
    }

    // EventEmitter cleanup happens automatically when objects are destroyed
    // since your EventEmitter instances will be garbage collected

    // Remove from window
    if (window.experience) {
      delete window.experience;
    }

    // Reset singleton instance
    instance = null;
  }

  // Method to emit loading completion event
  setLoadingComplete() {
    this.trigger("loadingComplete");
  }
}
